import React, { useEffect, useState } from "react";
import { useForm, useWatch } from 'react-hook-form';
import { CheckOtpCode } from "../../services/client/auth/checkOtp";
import { ResendOtp } from "../../services/client/auth/resendOtp";
import { useMutation } from "@tanstack/react-query";
import { toastOptions } from "../../features/toast/toast";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useModal } from "../../context/modalContext";
import { IconClock, IconSend } from "@tabler/icons-react";
// @ts-ignore
import Cookies from "js-cookie";
import { onError } from "../../features/error/error";
import { SendCart } from "../../services/panel/cart/sendCart";
import { Step } from "../../features/step/step";

const CheckOtp = () => {
    const { register, handleSubmit, control }: any = useForm<any>({
        defaultValues: {
            text: { 1: '', 2: '', 3: '', 4: '' },
        },
    });
    const { isModalOpen } = useModal();
    const [disabled, setDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState<number | null>(null);

    const textValues = useWatch({ control, name: 'text' });

    useEffect(() => {
        // @ts-ignore
        const allFilled = Object.values(textValues).every((value: string) => value.length === 1);
        if (allFilled) {
            const form = document.querySelector('#submit-otp');
            if (form) {
                // @ts-ignore
                form.click();
            }
        }
    }, [textValues]);

    const Cartmutation = useMutation({
        mutationFn: SendCart,
        onSuccess: (data) => {
            localStorage.setItem('cart', '');
            window.location.reload();
        },
        onError: (error) => {
            window.location.reload();
        },
    });

    const mutation = useMutation({
        mutationFn: CheckOtpCode,
        onSuccess: (data) => {
            toast.success('با موفقیت وارد شدید', toastOptions);
            let items = JSON.parse(localStorage.getItem('cart') || '[]');
            const simplifiedArray = items.map((item: { product_id: any; variation_id: any; quantity: any; }) => ({
                product_id: item.product_id,
                variation_id: item.variation_id,
                quantity: item.quantity,
            }));
            let dataNew: any = {
                items: simplifiedArray,
            };
            Cookies.set('agent_token', Cookies.get('first_token') || '', { expires: 7 });
            localStorage.setItem('cart', '');
            Cartmutation.mutate(dataNew);
        },
        onError: () => {
            toast.error('دوباره تلاش کنید...', toastOptions);
        },
    });

    const ResendMutation = useMutation({
        mutationFn: ResendOtp,
        onSuccess: (data) => {
            toast.success('کد با موفقیت ارسال شد', toastOptions);
            Cookies.set('first_token', data.token);
            timer();
        },
        onError: () => {
            toast.error('دوباره تلاش کنید...', toastOptions);
        },
    });

    const onSubmit = (data: any) => {
        let array = data.text;
        let otpValue = array[4] + array[3] + array[2] + array[1];
        let value: any = {
            otp: otpValue,
        };
        mutation.mutate(value);
    };

    const Resend = () => {
        let data: any = {};
        ResendMutation.mutate(data);
    };

    const timer = () => {
        setDisabled(true);
        setTimeLeft(60);
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev !== null && prev > 1) {
                    return prev - 1;
                } else {
                    clearInterval(interval);
                    setDisabled(false);
                    return null;
                }
            });
        }, 1000);
        return () => clearInterval(interval);
    };

    useEffect(() => {
        if (isModalOpen) {
            timer();
        }
    }, [isModalOpen]);

    return (
        <>
            <section className={`modal fade`} id="otp">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content rounded rounded-4">
                        <div className="modal-body">
                            <div className="text-center w-100">
                                <img
                                    alt="logo"
                                    className="brand-logo acband-price-icon"
                                    src={require('./../../assets/media/logo/final.png')}
                                />
                            </div>
                            <div className="content p-md-4 p-2 pt-1">
                                <div className="texts text-center">
                                    <p className="h3 fw-bold text-center">ورود و ثبت نام</p>
                                    <p className="text mt-3 text-center">
                                        کد ارسال شده را وارد نمایید
                                        <span className="ms-2 fw-bold text-site" data-bs-target="#agent" data-bs-toggle="modal">
                                            (بازگشت)
                                        </span>
                                    </p>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit, onError)}>
                                    <div className="row justify-content-center mb-3">
                                        {Array.from({ length: 4 }).map((_, index) => (
                                            <div key={index + "form"} className="col-2">
                                                <input
                                                    onKeyDown={(e) => Step(e, index, `digit`)}
                                                    maxLength={1}
                                                    id={`digit${index}`}
                                                    className="form-control text-center ltr step-input"
                                                    {...register(`text.${index + 1}`, { required: 'یکی از فیلدای کد رو فراموش کردی' })}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <button id="submit-otp" disabled={mutation.isPending} className="btn btn-outline-primary w-100 mt-2 py-3">
                                        {mutation.isPending ? 'در حال ارسال' : 'تایید'}
                                    </button>
                                    {isModalOpen ? (
                                        <button
                                            onClick={() => Resend()}
                                            type="button"
                                            disabled={disabled}
                                            className="border-0 bg-white mt-3"
                                        >
                                            <span className="mt-3 font-medium-lg text-site">
                                                {timeLeft !== null ? <IconClock size={14} /> : <IconSend size={14} />}
                                                <span className="ms-1">{timeLeft}</span>
                                                <span className="ms-1">
                                                    {timeLeft !== null ? 'ثانیه تا ارسال دوباره' : 'ارسال دوباره'}
                                                </span>
                                            </span>
                                        </button>
                                    ) : null}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CheckOtp;